export class GetActionAssignmentOptions {
	static readonly type = '[Workflow] GetActionAssignmentOptions';
	constructor(public actionItem: string, public index: number) {}
}

export class GetActionItemOptions {
	static readonly type = '[Workflow] GetActionItemOptions';
	constructor(public actionType: string, public index: number) {}
}

export class GetActionTriggerOptions {
	static readonly type = '[Workflow] GetActionTriggerOptions';
	constructor() {}
}

export class GetActionTypeOptions {
	static readonly type = '[Workflow] GetActionTypeOptions';
	constructor() {}
}

